/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-13 10:44:00
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/TermsAndConditions/index.tsx
 */
import React from 'react';
import TcTable from 'src/constrains/TermsAndConditionsTableSelection';
import { CheckoutErrorContext } from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/ErrorContext';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const TermsAndConditions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { tcEmptyError, setTcEmptyError } =
    React.useContext(CheckoutErrorContext);

  const { data, onChange, setHasModified, tcs, disableEdit } = props;

  return (
    <SectionWrapper
      title={getI18n('salesChannelCheckout.index.checkoutTermsConditions')}>
      <TcTable
        disableEdit={disableEdit}
        data={data}
        onChange={onChange}
        setHasModified={setHasModified}
        tcs={tcs}
        error={{
          tcEmptyError,
          setTcEmptyError,
        }}
        id='SalesChannelCheckoutTCTable'
      />
      {/* {visible && (
        <TCModals
          tcs={tcs}
          selectedItems={data}
          onOk={handleOnChange}
          onCancel={handleOnClose}
          visible={visible}
        />
      )}
      <DroppableTable
        //rowSelection={row}
        error={
          tcEmptyError ? 'Please select at least one terms & conditions' : null
        }
        pagination={false}
        rowKey={(record) => {
          const uuid = get(record, 'uuid');
          return uuid;
        }}
        dataSource={data || []}
        columns={col(handleOnDelete)}
        id='SalesChannelCheckoutTCTable'
        onTableChange={handleOnFieldSort}
        // rowDeleteFunc={deleteProduct}
      />
      <Button onClick={handleOnAdd} type='primary' className={css.addNew}>
        Select Terms & Conditions
      </Button>
      <div className={css.configContainer}>
        <Configuration
          configStart='Go to Store > Sales Channel'
          configLink='Legal'
          linkTo={`/legalPage/${uuid}`}
          configEnd='to manage Terms & Conditions.'
        />
      </div> */}
    </SectionWrapper>
  );
};
export default TermsAndConditions;
